import { render } from "./about-us-scr.vue?vue&type=template&id=3a021fe7&scoped=true"
import script from "./about-us-scr.vue?vue&type=script&lang=js"
export * from "./about-us-scr.vue?vue&type=script&lang=js"

import "./about-us-scr.vue?vue&type=style&index=0&id=3a021fe7&scoped=true&lang=css"

import exportComponent from "/Users/achinthaprabasha/Desktop/work/yathra/yathra-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a021fe7"]])

export default __exports__